export class FurCabSeguimiento {
    cantExpediente = 0;
    cantFormWeb = 0;
    cantOtros = 0;
    cantFur = 0;
}
